<script>
import Button from '@/components/Button.vue'

export default {
  components: {
    Button,
  },
  name: 'ManualVerifyAmloButton',
  props: {
    value: Boolean,
    isRmRequested: Boolean,
    isDisableCheckAmloBtn: Boolean,
  },
  model: {
    event: 'change',
  },
  data: function () {
    return {
      isManualVerifyAmlo: false,
    }
  },
  methods: {
    manualVerifyAmlo: function () {
      this.isManualVerifyAmlo = true
      this.$emit('change', true)
    },
  },
}
</script>

<template>
  <div v-if="isRmRequested">
    <div v-if="!isManualVerifyAmlo">
      <Button
        id="manual-check-amlo"
        type="info"
        class="btn-dark btn-s-xs"
        :disabled="isDisableCheckAmloBtn"
        @click.native="manualVerifyAmlo"
      >
        <i class="fa fa-search"></i> ตรวจสอบ AMLO
      </Button>
    </div>
    <div v-else>
      <Button id="manual-check-amlo" type="primary" class="btn-dark btn-s-xs" disabled>
        <i class="fa fa-check-circle-o"></i> ผ่าน AMLO
      </Button>
    </div>
  </div>
</template>
